export default __webpack_public_path__ + "static/media/list_1.8e765190.png";